/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { GrpcInstrumentation } from './instrumentation';
export type { GrpcInstrumentationConfig } from './types';
